import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import { Nav, Collapse, Box, Text, CaretDownOutlined, Badge } from '@landr/maestro';
import { StyledCollapse, CollapseIconBox, StyledLeftBorder } from './styled.es.js';

var NavCollapseHead = function NavCollapseHead(_ref) {
  var children = _ref.children,
    title = _ref.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var handleOnClick = function handleOnClick() {
    setIsOpened(!isOpened);
  };
  return /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(StyledCollapse, {
    p: 0,
    minHeight: "unset"
  }, /*#__PURE__*/React.createElement(Collapse.Trigger, null), /*#__PURE__*/React.createElement(Collapse.Title, {
    // Issue: Property 'onClick' does not exist on type
    // https://github.com/LandrAudio/LANDR.Maestro/issues/973
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onClick: handleOnClick
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    py: "xs"
  }, /*#__PURE__*/React.createElement(Text, {
    ml: "xs",
    size: "lg",
    fontWeight: "bold",
    color: "neutral.400"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    ml: "md"
  }, /*#__PURE__*/React.createElement(CollapseIconBox, {
    isOpened: isOpened,
    height: "24px"
  }, /*#__PURE__*/React.createElement(CaretDownOutlined, {
    color: "neutral.400"
  }))))), /*#__PURE__*/React.createElement(Collapse.Content, {
    p: "xs"
  }, /*#__PURE__*/React.createElement(StyledLeftBorder, null, children))));
};
var BadgeTitle = function BadgeTitle(_ref2) {
  var content = _ref2.content;
  if (content) {
    return /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      ml: "xs"
    }, /*#__PURE__*/React.createElement(Badge, {
      size: "sm",
      variant: "secondary",
      content: content
    }));
  }
  return null;
};
var Item = function Item(_ref3) {
  var onClick = _ref3.onClick,
    href = _ref3.href,
    text = _ref3.text,
    badgeTitle = _ref3.badgeTitle;
  return /*#__PURE__*/React.createElement(Nav.Link, {
    onClick: onClick,
    href: href,
    sx: {
      whiteSpace: 'normal'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    fontWeight: "bold",
    lineHeight: "md"
  }, text), /*#__PURE__*/React.createElement(BadgeTitle, {
    content: badgeTitle
  }));
};
var NavCollapse = {
  Head: NavCollapseHead,
  Item: Item
};

export { NavCollapse };
